export default "__VITE_ASSET__DIU2aZL3__"